/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useState, useRef, useEffect } from 'react';
import { toast } from 'react-toastify';
import { FormGroup } from '../../common';
import { Button, Heading, Text } from '../../styledComponents';
import styles from './ChangePasswordModal.module.css';
import { changePassword } from '../../../services/dashboard.service';

type ChangePasswordModalProps = {
  profileId: string;
  fetchHomePageData: () => void;
  setShowChangePasswordModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function ChangePasswordModal({
  profileId,
  fetchHomePageData,
  setShowChangePasswordModal,
}: ChangePasswordModalProps) {
  const [discountCodeName, setDiscountCodeName] = useState<string>('');
  const [disableButton, setDisableButton] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [oldPassword, setOldPassword] = useState<string>('');
  const [newPassword, setNewPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const modalRef = useRef<null | HTMLDivElement>(null);

  const handleOutsideClick = (e: any) => {
    if (!modalRef.current?.contains(e.target)) {
      setShowChangePasswordModal(false);
    }
  };

  const handleChangeCreatorPassword = async () => {
    if (oldPassword.trim() === newPassword?.trim()) {
      setErrorMessage('Old Password & New Password cannot be same!');
      return;
    }
    if (newPassword.trim() !== confirmPassword.trim()) {
      setErrorMessage('New Password & Confirm Password are not matching!');
      return;
    }

    setDisableButton(true);
    const body = {
      creatorId: profileId,
      oldPassword,
      newPassword,
      confirmPassword,
    };
    // api call here
    const response: any = await changePassword(body);

    if (response?.status) {
      toast.success(response?.message || response?.data?.message || 'Password Changed Succesfully!');
      setShowChangePasswordModal(false);
      fetchHomePageData();
      setDisableButton(false);
    } else {
      toast.error(response?.data?.message || response?.message || 'Something Went Wrong!');
      setErrorMessage(response?.data?.message || response?.message || 'Something Went Wrong!');
      setDisableButton(false);
    }
  };

  return (
    <div className={styles.modalWrapper} onClick={handleOutsideClick}>
      <div className={styles.modal} ref={modalRef}>
        <div className={styles.formSection}>
          <Heading as="h3" fontWeight="500" fontSize="16px" color="#353535" textTransform="uppercase">
            Change Password
          </Heading>
          <FormGroup
            name="oldPassword"
            label="Old Password"
            type="text"
            placeholder=""
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            errorText=""
            required
            autoFocus
          />

          <FormGroup
            name="newPassword"
            label="New Password"
            type="password"
            placeholder=""
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value?.trim())}
            errorText=""
            required
          />

          <FormGroup
            name="confirmPassword"
            label="Confirm Password"
            type="text"
            placeholder=""
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value?.trim())}
            errorText=""
            required
          />

          {/* error message here */}
          {errorMessage && <Text color="var(--red)">{errorMessage}</Text>}

          <div className={styles.group}>
            <Button
              bgColor="transparent"
              color="var(--dark-grey)"
              style={{ border: '1px solid var(--light-grey)' }}
              type="button"
              onClick={() => setShowChangePasswordModal(false)}
            >
              Cancel
            </Button>
            <Button
              bgColor="var(--saral-purple)"
              type="button"
              onClick={handleChangeCreatorPassword}
              disabled={!oldPassword || !newPassword || !confirmPassword || disableButton}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
